import type { ApiConfig } from '../declare'

const apis: ApiConfig[] = [
  {
    name: 'getTableConfig',
    method: 'GET',
    path: '/OP/Form/GetTableConfig',
    params: {
      Key: '',
      OrgId: ''
    },
    desc: '获取列表表单配置信息'
  },
]

export default apis